import { render, staticRenderFns } from "./CompanyTable.vue?vue&type=template&id=5a0c1e53"
import script from "./CompanyTable.vue?vue&type=script&lang=js"
export * from "./CompanyTable.vue?vue&type=script&lang=js"
import style0 from "./CompanyTable.vue?vue&type=style&index=0&id=5a0c1e53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports